module.exports = __webpack_public_path__ + "UA.png?e24827ce192348c8f06fc52f98244a44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/UA.png
// module id = 415
// module chunks = 0